import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, throwError } from 'rxjs';
import { ApiServiceService } from '../../../services/api-service.service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {

  refreshList = new BehaviorSubject<boolean>(false);

  constructor(private apiService: ApiServiceService) { }


  getAll(filterModel: any): any {
    return this.apiService.get(`${environment.apiUrl}/categories`, filterModel)
      .pipe(catchError(this.handleError));
  }

  getAllWithoutPermission(filterModel: any): any {
    return this.apiService.get(`${environment.apiUrl}/categories/list`, filterModel)
      .pipe(catchError(this.handleError));
  }

  getCategoriesWithoutPermission(model: any): any {
    return this.apiService.get(`${environment.apiUrl}/categories-with-children`, model)
      .pipe(catchError(this.handleError));
  }

  delete(id: any) {
    return this.apiService.remove(`${environment.apiUrl}/categories/${id}`)
      .pipe(catchError(this.handleError));
  }

  getCategoryById(roleId: any) {
    return this.apiService.get(`${environment.apiUrl}/categories/${roleId}`)
      .pipe(catchError(this.handleError));
  }

  saveCategory(data: any, id: any = null) {
    if (id) {
      return this.apiService.post(`${environment.apiUrl}/categories/${id}`, data)
        .pipe(catchError(this.handleError));
    } else {
      return this.apiService.post(`${environment.apiUrl}/categories`, data)
        .pipe(catchError(this.handleError));
    }
  }

  // Get All Sub Categories for Specific Vendor
  getVendorSubCategories(vendorId: any, mainCategoryId: any) {
    return this.apiService.post(`${environment.apiUrl}/vendors-registration-request/vendor-sub-category/?vendor_id=${vendorId}&main_cat_id=${mainCategoryId}`)
      .pipe(catchError(this.handleError));
  }

  handleError(error: any) {
    return throwError(error);
  }

}